// eslint-disable-next-line max-len
export default "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path data-name=\"plus icon\" d=\"M11.072 18.5v-5.572H5.5v-1.856h5.572V5.5h1.856v5.572H18.5v1.856h-5.572V18.5Z\" fill=\"#ff3700\"/></svg>";
